const showGlobalNotice = (page) =>
  page && page.slug && page.slug === "homepage";

export default showGlobalNotice;
